export const useLoading = ({ root } = { root: 'loading' }) => ({
  data() {
    return {
      [root]: {},
    }
  },

  methods: {
    startLoading(key) {
      this.$set(this[root], key, true)
    },

    finishLoading(key) {
      this.$set(this[root], key, false)
    },

    allocateLoading(keys) {
      keys = Array.isArray(keys) ? keys : [keys]

      keys.forEach(key => this.$set(this[root], key, false))
    },

    async asyncLoad(key, fn) {
      this.startLoading(key)

      try {
        return await fn()
      } finally {
        this.finishLoading(key)
      }
    },
  },

  computed: {
    isLoading() {
      return Object.values(this[root]).some(Boolean)
    },
  },
})
